import {Component, Input, OnInit} from '@angular/core';
import {TranslatePipe} from '@ngx-translate/core';
import {isMobile, ORDER_STATUS_LABEL} from 'app/core/helpers/constants';
import {InsuranceOrderHistory} from '../../../../core/models/insurance-order';
import {BenefitHistoryType} from '../../../../core/helpers/enums';

@Component({
  selector: 'app-insurance-history-table',
  templateUrl: './insurance-history-table.component.html',
  styleUrls: ['./insurance-history-table.component.scss'],
  providers: [TranslatePipe],
})
export class InsuranceHistoryTableComponent implements OnInit {
  @Input() orders: InsuranceOrderHistory[] = [];
  @Input() subdomain: string;

  public isMobile = false;
  protected readonly BenefitHistoryType = BenefitHistoryType;

  getOrderStatusLabel(status: number | null): string {
    return status != null ? ORDER_STATUS_LABEL[status] : null;
  }

  ngOnInit(): void {
    this.isMobile = isMobile();
  }
}
